<template>
    <v-row justify="center">
        <v-list-item class="mt-5 "

                     color="primary"
                     dark
                     @click.stop="disableModal"

        >
            <v-list-item-icon>
                <v-img src="../../../../../assets/svg/complaint.svg" class="invite-box"></v-img>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title class="invite">Invite for Interview</v-list-item-title>
            </v-list-item-content>
        </v-list-item>


        <v-dialog
                v-model="dialog"
                width="450"
        >
            <v-card>
                <Loader :loading="loading" :message="message"/>
                <v-toolbar class="box"  @click.stop="dialog = false" >
                    <v-icon>mdi-close</v-icon>
                    <v-toolbar-title>Close</v-toolbar-title>
                </v-toolbar>
                <div class="invite-content">
                    <v-card-title class="invite-heading">Interview schedule</v-card-title>

                <v-card-text class="invite-info">
                    Send an interview schedule request to this applicant via email.
                </v-card-text>
                    <div v-if="responseMsg" class="red--text mb-2">
                        {{responseMsg}}
                    </div>

                    <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            ref="menu2"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="interviewDate"
                                    label="Set new date "
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    class="ml-3 mr-2 invite-input"

                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" :min="new Date().toISOString().substr(0,10)" >
                            <v-spacer></v-spacer>
                            <v-btn  depressed color="primary" @click="menu2 = false">Cancel</v-btn>
                            <v-btn  depressed color="primary" @click="$refs.menu2.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>

                    <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="interviewTime"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                    v-model="interviewTime"
                                    label="Set new time"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    class="ml-3 mr-2 invite-input"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                                v-model="interviewTime"

                        >
                            <v-btn  depressed color="primary" @click="menu1 = false">Cancel</v-btn>
                            <v-btn  depressed color="primary" @click="$refs.menu1.save(interviewTime)">OK</v-btn>
                        </v-time-picker>
                    </v-menu>
                    <v-textarea
                            outlined
                            name="input-7-4"
                            height="100px"
                            class="ml-3 mr-2 invite-input"
                            label="Write message (optional)"
                            v-model="optionalInvitationComment"
                    ></v-textarea>
                <v-card-actions>
                    <v-btn
                            color="red"
                            outlined
                            x-large
                            @click="dialog = false"
                    >
                     Cancel
                    </v-btn>

                    <v-btn
                            color="error"
                            depressed
                            x-large
                            @click="sendInterviewInvite"
                            class="ml-5"
                    >
                        Send invite
                    </v-btn>
                </v-card-actions>

                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import axios from 'axios'
    import {inviteForInterview} from "../../../../../services/ApiServices";
    import {mapGetters} from "vuex";
    import Loader from "./Loader";
    export default {
        name: "InterviewDialog",
        components: {Loader},
        data:vm=> ( {

                dialog: false,
                date: null,
                interviewDate: vm.formatDate(new Date().toISOString().substr(0, 10)),
                interviewTime:null,
                menu2:false,
                menu1:false,
                optionalInvitationComment: "",
                interviewMethod: "ONLINE",
                loading:false,
                message:"Loading...",
                responseMsg:''


        }),
        methods:{
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}-${month}-${year}`
            },
            disableModal(){
                this.dialog = this.applicant.applicationStatus === 'TESTED';

            },

            sendInterviewInvite(){
                this.loading=true
               const elderHeader=JSON.parse(sessionStorage.getItem('headers'))
                axios.post(inviteForInterview,{
                    applicantEmail: this.applicantEmail,
                    optionalInvitationComment: this.optionalInvitationComment,
                    interviewDate: this.interviewDate,
                    interviewTime: this.interviewTime,
                    interviewMethod : this.interviewMethod

                },{headers:elderHeader
                }).then(res=>{
                    console.log(res.data)
                        this.loading=false
                    this.responseMsg= res.data.message;
                    this.dialog=false;
                    this.$store.dispatch('fetchApplicantByEmail',this.applicantEmail)

                }).catch(err=>{
                    this.loading=false;
                    console.log(err.response)
                    if(err.response === undefined) {
                        this.responseMsg = "Check your internet connection"
                    }else {
                        this.responseMsg= err.response.data.message;
                    }
                })
                const {interviewDate,interviewTime} = this ;
                console.log(interviewDate,interviewTime)
            }

        },
        computed: {
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
            ...mapGetters(['applicantEmail','applicant'])
        },


        watch: {
            date () {
                this.interviewDate = this.formatDate(this.date)
            },
        },

    }


</script>

<style scoped>
    .invite{
        font-family: IBM Plex Sans;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center !important;
        letter-spacing: 0.02em;
        color: #FF7E1D;
    }
    .invite-heading{
        font-weight: 500!important;
        font-size: 30px !important;
        line-height: 33px!important;
        letter-spacing: -0.02em;
        color: #2B1C1C !important;
    }
    .invite-info{
        font-size: 14px !important;
        line-height: 18px !important;
        color: #2B1C1C;
    }
    .invite-input{
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center!important;
        letter-spacing: 0.05em;

        color: #2B1C1C !important;
    }
    .invite-box{
        background: #FFDDD9;
        border-radius: 8px;
        padding: 3px;
    }
    .box{
        box-shadow: none!important;
        cursor: pointer;
    }
    .invite-content{
        margin-left: 55px;
        margin-right: 55px;
        font-family: IBM Plex Sans !important;
        font-style: normal!important;
        font-weight: normal;

    }

</style>